module.exports = function getResource(label, vars = []) {
    let resources = {
        main: 'En cours chez Sephora',
        myReservations: 'Mes réservations',
        findASephora: 'Trouver un Sephora',
        happeningAtSephoraNavigation: 'En cours chez Sephora Navigation',
        beautyServicesFaq: 'FAQ sur les services beauté',
        makeupServices: 'Services de maquillage'
    };
    return resources[label];
};
